import { render, staticRenderFns } from "./targets.vue?vue&type=template&id=6821f308&scoped=true&"
import script from "./targets.vue?vue&type=script&lang=js&"
export * from "./targets.vue?vue&type=script&lang=js&"
import style0 from "./targets.vue?vue&type=style&index=0&id=6821f308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6821f308",
  null
  
)

export default component.exports